export function BrandedSplash({ label = "Loading" }) {
  return (
    <div
      data-testid="branded-splash"
      className="min-h-screen flex flex-col items-center justify-center bg-background gap-5"
    >
      <div className="relative">
        <span className="absolute inset-0 rounded-2xl bg-blue-500/25 blur-2xl animate-pulse" />
        <img
          src="/controlly-icon.png"
          alt="Controlly"
          className="relative w-16 h-16 rounded-2xl animate-in fade-in zoom-in-95 duration-500"
        />
      </div>
      <div className="flex flex-col items-center gap-2">
        <span className="font-heading text-lg font-extrabold tracking-tight">Controlly</span>
        <div className="flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-bounce [animation-delay:-0.3s]" />
          <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-bounce [animation-delay:-0.15s]" />
          <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-bounce" />
        </div>
        <span className="sr-only">{label}</span>
      </div>
    </div>
  );
}
